<template>
    <div>
        <!-- <subNavbar :list="nav.zoujinditan" @click="subNavbarItemClick"/> -->
        <div>
            <img src="../assets/banner/WalkIntoBanner.jpg">
        </div>
        <!-- style="width: 1600px;margin-left:380px;margin-right: 20px;" -->
        <!-- <div  class="container margin-auto margin-top-30"> -->
            <orderMenu :list="nav.zoujinditan" ref="orderMenu" />
        <!-- </div> -->
    </div>
</template>

<script>
import subNavbar from '../components/subNavbar'
import orderMenu from '../components/orderMenu'
import { mapGetters, mapMutations } from 'vuex'
export default {
    name: 'WalkInto',
    components: {
        subNavbar,
        orderMenu
    },
    computed: {
        ...mapGetters({
            nav: 'getNav'
        })
    },
    watch: {
        '$route': 'getIndex'
    },
    data() {
        return {
            // list:[
            //     {title:'公司简介',html:'公司简介'},
            //     {title:'创始人的信仰',html:'创始人的信仰'},
            //     {title:'资质荣誉',html:'资质荣誉'},
            //     {title:'企业文化',html:'企业文化'},
            //     {title:'企业架构',html:'企业架构'},
            //     {title:'战略合作',html:'战略合作'},
            // ]
        }
    },
    methods: {
        subNavbarItemClick(index) {
            this.$refs.orderMenu.setActive(index)
        },
        getIndex() {
            // console.log(this.$route.query.index)
            this.subNavbarItemClick(this.$route.query.index)
        }
    },
    mounted() {
        if (this.$route.query.index) {

            this.subNavbarItemClick(this.$route.query.index)
        }
    }
}
</script>

<style lang="scss" scoped></style>